import * as qplsService from '../../services/Qpls/qplsService'
import {gridsNames} from '../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.COC_TESTS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {

    const cocId = getState().coc.getIn(['cocView', 'cocId']);
    query.pageSize = 1000;
    return cocId ? qplsService.fetchCoCTests(cocId, query) :  Promise.resolve([]);
  }
}

function _convertToRowData(rows) {
  return rows;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
